import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar"; 
import Header from "./Header"; 
import { CrossIcon, X } from "lucide-react";

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [showProfileBanner, setShowProfileBanner] = useState(() => {
    return localStorage.getItem("hideProfileBanner") !== "1";
  });

  const user = useSelector(state => state.user?.user || state.user);

  function isAnyMandatoryFieldMissing(user) {
    if (!user) return true;
    const required = [
      user.name,
      user.address?.country,
      user.defaultCurrency,
      user.email,
      user.phone,
      user.dateOfBirth
    ];
    return required.some(v => !v || v === "NA");
  }

  useEffect(() => {
    function checkBanner() {
      if (localStorage.getItem("hideProfileBanner") === "1") {
        setShowProfileBanner(false);
        return;
      }
      const percent = Number(localStorage.getItem("profileCompletionPercent"));
      if (percent === 100) {
        setShowProfileBanner(false);
        return;
      }
      setShowProfileBanner(isAnyMandatoryFieldMissing(user));
    }

    checkBanner();
    const interval = setInterval(checkBanner, 1000);
    return () => clearInterval(interval);
  }, [user]);

  const toggleMainSidebar = () => {
    setIsSidebarCollapsed(prev => !prev);
  };

  useEffect(() => {
    if (!isSidebarCollapsed) {
      document.body.classList.add("sidebar-activated");
    } else {
      document.body.classList.remove("sidebar-activated");
    }
    return () => document.body.classList.remove("sidebar-activated");
  }, [isSidebarCollapsed]);

  useEffect(() => {
    if (window.location.pathname.includes("dashboard")) {
      document.body.classList.add("dashboard-page");
    }
    return () => document.body.classList.remove("dashboard-page");
  }, []);

  return (
    <div className="layout-container">
      {/* ================= PROFILE BANNER ================= */}
      {showProfileBanner && (
        <div className="profile-banner position-relative">
          <p>Update and complete your profile</p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/editprofile")}
          >
            Update now
          </button>
          <span className="pink-dot" />
          <button
            type="button"
            className="btn btn-link position-absolute top-0 h-full end-0 text-secondary text-text-decoration-none hover:opacity-75"
            onClick={() => {
              setShowProfileBanner(false);
              localStorage.setItem("hideProfileBanner", "1");
            }}
          >
            <X/>
          </button>
        </div>
      )}

      {/* ================= LAYOUT ================= */}
      <div className="layout">
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          toggleMainSidebar={toggleMainSidebar}
        />
        <div className="content">
          <Header isSidebarCollapsed={isSidebarCollapsed} />
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
